
<gw-dialog id="dialogModal" #dialogModal="gwDialog"></gw-dialog>
<gw-loader id="navigationLoader" [position]="'fixed'"></gw-loader>
<router-outlet></router-outlet>
<simple-notifications [options]="notificationOptions"></simple-notifications>